import React from 'react'
import cn from 'clsx'
import styles from './index.module.css'

type Props = {
  content: string
}

/**
 * A text overflow component that displays text with ellipsis overflow and full content on hover
 * @param content - The text content to display
 * @returns A span element with text overflow handling and title tooltip
 */
const TextOverflow = ({ content }: Props) => (
  <span className={cn('overflow-ellipsis', styles.textOverflow)}>
    <span
      className={cn('overflow-ellipsis', styles.textOverflowContent)}
      title={content}
    >
      {content}
    </span>
  </span>
)

export default React.memo<Props>(TextOverflow)
